module.exports = __webpack_public_path__ + "static/media/sider-main.styles.00ade37d.less";